module.exports = __webpack_public_path__ + "static/img/Logo10_Anantara.690ad6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo10_Anantara.png
// module id = 236
// module chunks = 1